import {
    CREATE_PASSAGER,
    CREATE_PASSAGER_SUCCESS,
    CREATE_PASSAGER_API_ERROR,
} from "./actionTypes"



export const createPassager = (params, callBackSuccess) => {
    return {
        type: CREATE_PASSAGER,
        payload: {params, callBackSuccess}
    }
}

export const createPassagerSuccess = data => {
    return {
        type: CREATE_PASSAGER_SUCCESS,
        payload: { data }
    }
}

export const apicreatePassagerError = error => {
    return {
        type: CREATE_PASSAGER_API_ERROR,
        payload: { error },
    }
}

export const submitFormRequest = data => { 
    //@to-do continue
    console.log('submitFormRequest', data) 
}
